import * as React from "react";
import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { InputBase } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ClearIcon from "@mui/icons-material/Clear";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import Pagination from "@mui/material/Pagination";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDateYMD_HMS } from "../util/helper";
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import CardContent from "@mui/material/CardContent"; 
import Container from "@mui/material/Container"; 

const TableUrlLookupResult = ({
  rows,
  columns,
  totalPage,
  onSearch,
  loading,
  currentPage,
  searchRange,
}) => {
  const [sort, setSort] = useState({ column: "id", order: "" });
  const [open, setOpen] = React.useState(false);

  const handleChangePage = (event, value) => {
    onSearch({ currentPageChange: value, sort }); // call the callback function with the search parameters
  };

  const downloadCSV = () => {
    // Extracting column names
    const columnNames = [...columns.map((column) => column.headerName), 'comment'];

    // Creating an array of rows with column names
    const rows_data = [columnNames].concat(
      rows.map((row) => [
        formatDateYMD_HMS(row.created),
        row.user,
        row.url,
        row.brand,
        row.is_phish,
        row.feedback,
        row.comments
      ])
    );

    const csvContent = rows_data
      .map((row) => row.map(value => `"${value}"`).join(','))
      .join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `1URL Usage Result.csv`;
    link.click();
  };

  const [openRows, setOpenRows] = useState(Array(rows?.length).fill(false));

  const handleRowToggle = (index) => {
    const updatedOpenRows = [...openRows];
    updatedOpenRows[index] = !updatedOpenRows[index];
    setOpenRows(updatedOpenRows);
  };


  return (
    <Box
      sx={{
        paddingTop: "40px",
        borderRadius: "4px",
      }}
    >
      <Box width="98%" margin="auto">
        <Grid
          container
          spacing={2}
          style={{ marginBottom: "25px" }}
        >
          <Grid item md={9}>
            <Typography
              fontSize={20}
              color="#707070"
              style={{ textAlign: "left" }}
            >
              {searchRange}
            </Typography>
          </Grid>

          <Grid item md={3}>
            <Box mt={1} style={{ float: "right" }}>
              <Box
                padding="11px"
                sx={{
                  backgroundColor: "#2699fb",
                  color: "white",
                  borderRadius: "4px",
                  "&:hover": {
                    cursor: "pointer",
                  },
                  width: "200px",
                }}
                onClick={downloadCSV}
              >
                <Typography
                  variant="body1"
                  gutterBottom
                  textAlign="center"
                  m={0}
                  cursor="pointer"
                >
                  Download CSV
                </Typography>
              </Box>
            </Box>
          </Grid>

        </Grid>

      </Box>

      <Box width="98%" margin="20px auto 0px">
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "none",
            boxShadow: "none",
          }}
        >
          <Table sx={{ minWidth: 750}} aria-label="simple table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                {columns?.map((colum) => (
                  <TableCell
                    key={colum.field}
                    sx={{
                      cursor: "pointer",
                      borderBottom: "1px solid #808182 !important",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#707070",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {colum?.headerName}
                      {colum.field == sort.column ? (
                        sort.order ? (
                          <ArrowDropDownIcon sx={{ color: "black" }} />
                        ) : (
                          <ArrowDropUpIcon sx={{ color: "black" }} />
                        )
                      ) : (
                        ""
                      )}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loading ? (
              ""
            ) : (
              <TableBody sx={{ position: "relative" }}>
                {rows?.map((row, index) => (
                  <>
                    <TableRow
                      key={`${row.id}-${index}`}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "td, th": {
                          color: "#707070",
                          fontWeight: "bold",
                          fontSize: "16px",
                        },
                        backgroundColor: index % 2 === 1 ? "#f0f0f1" : "inherit",
                      }}
                    >

                      <TableCell sx={{ width: "13%" }}>
                        {formatDateYMD_HMS(row.created)}
                      </TableCell>

                      <TableCell>
                        {row.user}
                      </TableCell>

                      <TableCell
                        sx={{
                          minWidth: "75px",
                          wordBreak: "break-all",
                          backgroundColor: row?.changeColumn?.includes("url")
                            ? "#bfdbc3"
                            : "inherit",
                          color: row?.changeColumn?.includes("url")
                            ? "green !important"
                            : "inherit",
                        }}
                      >
                        {row.url}
                      </TableCell>

                      <TableCell
                        sx={{
                          wordBreak: "break-all",
                          backgroundColor: row?.changeColumn?.includes("brand")
                            ? "#bfdbc3"
                            : "inherit",
                          color: row?.changeColumn?.includes("brand")
                            ? "green !important"
                            : "inherit",
                        }}
                      >
                        {row.brand}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          width: "5%",
                        }}
                      >
                        {row.is_phish === true ? (
                          <RadioButtonUncheckedIcon sx={{ fontSize: "10px" }} />
                        ) : row.is_phish === null ? (
                          <HorizontalRuleIcon sx={{ fontSize: "10px" }} />
                        ) : (
                          <ClearIcon sx={{ fontSize: "10px" }} />
                        )}
                      </TableCell>

                      <TableCell align="center" sx={{ width: "5%" }}>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                        >
                          {row.feedback ? (
                            openRows[index] ? (
                              <KeyboardArrowUpIcon onClick={() => handleRowToggle(index)} />
                            ) : (
                              <KeyboardArrowDownIcon onClick={() => handleRowToggle(index)} />
                            )
                          ) : (
                            <ClearIcon sx={{ fontSize: "10px" }} />
                          )}
                        </IconButton>
                      </TableCell>

                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={6}
                      >
                        <Collapse in={openRows[index]} timeout="auto" unmountOnExit>
                        <CardContent style={{  
                            backgroundColor: "rgba(211,211,211,0.4)",
                            overflowY: "auto"
                        }}> 
                            <Container sx={{  
                                height: 100,  
                                lineHeight: 2  
                            }}> 
                                {row.comments}
                            </Container> 
                        </CardContent> 
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            )}
          </Table>
          {loading ? (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "160px",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <CircularProgress sx={{ color: "#2699fb" }} />
              </Box>
            </Box>
          ) : (
            ""
          )}
        </TableContainer>
      </Box>
      {!loading ? (
        <Box width="100%" padding="40px 0px" position="relative">
          {rows?.length ? (
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              page={currentPage}
              onChange={handleChangePage}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          ) : (
            <p>No data available</p>
          )}
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default TableUrlLookupResult;
